import { useAppContext } from '../../context/AppContext';
import { formatLabel } from '../../lib/huntDomain';
import GridCell from '../MainGrid/GridCell';
import gridStyles from '../MainGrid/MainGrid.module.css';
import styles from './LocationView.module.css';

const ALWAYS_ON_LAYERS = { sharedPlaces: true, hunted: true, duplicates: false };

export default function LocationView() {
  const { state, dispatch, derived, activeHunt } = useAppContext();
  const { photosByItem, sharedLocations } = derived;

  if (!activeHunt) return null;

  const huntList = activeHunt.huntList ?? [];
  const location = state.activeLocation;
  const isShared = sharedLocations.has(location);

  // Gather all items with at least one photo from this location
  const itemsHere = [];
  for (const [key, allPhotos] of photosByItem) {
    const photos = allPhotos.filter(p => p.location === location);
    if (photos.length > 0) itemsHere.push({ itemKey: key, photos });
  }
  itemsHere.sort((a, b) => a.itemKey.localeCompare(b.itemKey, undefined, { numeric: true }));

  function openDetail(itemKey) {
    dispatch({ type: 'OPEN_MODAL', modal: 'detail', data: { itemKey } });
  }

  function goBack() {
    dispatch({ type: 'SET_VIEW', view: 'grid' });
  }

  return (
    <div className={styles.view}>
      <div className={styles.page}>
        <button className={styles.backBtn} onClick={goBack}>← BACK</button>

        <div className={styles.header}>
          <div className={styles.displayFigure}>
            <span className={styles.displayNum}>{itemsHere.length}</span>
            <span className={styles.displayLabel}>found here</span>
          </div>
          <p className={styles.locationName}>{location}</p>
        </div>

        {itemsHere.length === 0 ? (
          <p className={styles.empty}>No photos from this location.</p>
        ) : (
          <div className={gridStyles.grid} style={{ padding: 0, margin: 0 }}>
            {itemsHere.map(({ itemKey, photos }) => {
              const primary = photos.find(p => p.isPrimary) ?? photos[0];
              return (
                <GridCell
                  key={itemKey}
                  itemKey={itemKey}
                  label={formatLabel(activeHunt.type, itemKey)}
                  photos={photos}
                  primaryPhoto={primary}
                  isInHuntList={huntList.includes(itemKey)}
                  isShared={isShared}
                  layers={ALWAYS_ON_LAYERS}
                  onClick={() => openDetail(itemKey)}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
